<template>
  <div class="row">
    <div class="col-sm-12 mb-3">
      <div class="order-origin-summary">
        <span class="order-origin-label">ORIGEN DE LA MERCADERÍA</span>
        <strong>
          <i :class="order.stockSource === 'distributor' ? 'fas fa-boxes' : 'fas fa-warehouse'"></i>
          {{ order.stockSource === 'distributor' ? 'MiDepósito' : 'Casa Central' }}
        </strong>
        <small v-if="order.stockSource === 'distributor'">Stock del distribuidor asignado al pedido</small>
        <small v-else>Disponibilidad general de Casa Central</small>
      </div>
    </div>

    <div class="col-sm-6 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA FACTURACIÓN: </label>
        <span>{{ order.billingDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA PRIMER PAGO: </label>
        <span>{{ order.firstPaymentDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">CANTIDAD DE PAGOS: </label>
        <span>{{ order.payments }}</span>
      </div>
    </div>

    <div v-if="order.dollarQuotation" class="col-sm-5 offset-sm-1 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA COTIZACIÓN DOLAR: </label>
        <span>{{ order.dollarQuotation.date | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">TIPO COTIZACIÓN: </label>
        <span>{{ order.dollarQuotationType | capitalize }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">COTIZACIÓN DOLAR: </label>
        <span>{{ dollarQuote | toCurrencyARS }}</span>
      </div>
    </div>

    <div v-else class="col-sm-5 offset-sm-1 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA COTIZACIÓN DOLAR: </label>
        <span>{{ order.dollarQuoteDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">COTIZACIÓN DOLAR: </label>
        <span>{{ +order.dollarQuote | toCurrencyARS }}</span>
      </div>
    </div>

    <div v-if="order.comment" class="col-sm-12 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">OBSERVACIONES: </label>
        <span>{{ order.comment }}</span>
      </div>
    </div>

    <div v-if="order.statusChangeComment" class="col-sm-12 col-xs-12">
      <div class="mt-2">
        <label class="control-label font-weight-bold mr-2">OBSERVACIONES SOBRE ESTADO DE PEDIDO: </label>
        <span>{{ order.statusChangeComment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    dollarQuote() {
      return Number(this.order.dollarQuotation[this.order.dollarQuotationType]);
    },
  },
};
</script>

<style scoped>
.order-origin-summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.9rem;
  border-left: 4px solid #f4c430;
  color: #344050;
  background: #f8fafc;
}

.order-origin-label {
  color: #8898aa;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.order-origin-summary strong i {
  margin-right: 0.35rem;
  color: #172b4d;
}

.order-origin-summary small {
  margin-left: auto;
  color: #6b7280;
}

@media (max-width: 767px) {
  .order-origin-summary {
    display: block;
  }

  .order-origin-summary strong,
  .order-origin-summary small {
    display: block;
    margin-top: 0.3rem;
    margin-left: 0;
  }
}
</style>
